import { useBuild } from "app/components/build/Show/lib/BuildContext";
import DisplayModeDropdown from "./DisplayModeDropdown";
import { StepList } from "./StepList";
import { AnnotationsLink } from "./AnnotationsLink";
import Emojify from "app/components/shared/Emojify";
import { BuildMeta } from "./BuildMeta";

export default function Sidebar() {
  const { build } = useBuild();

  return (
    <div
      className="absolute -left-2 -right-2 px-2 h-full overflow-y-auto no-scrollbar flex flex-col z-0"
      style={{ contain: "strict" }}
      data-testid="sidebar"
    >
      <div className="flex flex-col sticky top-0 bg-white z-10 gap-2">
        {!window.Features.BetterBuildsUIGA && build.project.description && (
          <Emojify className="line-clamp-2 text-charcoal-300" text={build.project.description} />
        )}

        {!Features.BetterBuildsUIGA && <AnnotationsLink {...build} />}

        {Features.BetterBuildsUIGA && <BuildMeta />}

        <div className="pb-0.5">
          <DisplayModeDropdown />
        </div>
      </div>

      <div className="flex flex-col gap-3 pt-0.5">
        <StepList />
      </div>
    </div>
  );
}
